import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { ArrowUpRight, Lock } from "lucide-react";

export default function QuizzesPage() {
  const [quizzes, setQuizzes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/quizzes")
      .then(({ data }) => setQuizzes(data))
      .catch((e) => toast.error(formatApiError(e)))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-16" data-testid="quizzes-page">
      <header className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-8">
          <div className="phenix-eyebrow mb-3">Chapitre · Récompenser</div>
          <h1 className="heading-display text-2xl lg:text-3xl text-plum-900">
            <em className="text-pink-500">Jouer.</em> Gagner.<br />
            Soutenir.
          </h1>
          <p className="mt-6 text-base text-plum-700/70 max-w-xl leading-relaxed">
            Répondez correctement à toutes les questions et remportez un bon de réduction utilisable chez nos commerçants partenaires.
          </p>
        </div>
      </header>

      {loading ? (
        <p className="text-plum-700/50 italic">Chargement...</p>
      ) : quizzes.length === 0 ? (
        <div className="border border-dashed border-cream-200 p-16 text-center text-plum-700/50 italic">
          Aucun quiz actif pour le moment.
        </div>
      ) : (
        <div className="grid md:grid-cols-2 gap-px bg-ink-900/10 border border-cream-200" data-testid="quiz-list">
          {quizzes.map((q, i) => (
            <Link
              key={q.id}
              to={q.played ? "#" : `/jeux/${q.id}`}
              data-testid={`quiz-play-btn-${q.id}`}
              className={`relative bg-cream-50 p-10 group transition-all duration-500 ${
                q.played ? "opacity-60 cursor-not-allowed" : "hover:bg-ink-900"
              }`}
            >
              <div className="flex items-start justify-between mb-12">
                <div className="font-mono text-[11px] text-plum-700/50 group-hover:text-paper-100/50">
                  {String(i + 1).padStart(2, "0")} / {String(quizzes.length).padStart(2, "0")}
                </div>
                {q.played ? (
                  <Lock size={14} strokeWidth={1.25} className="text-plum-700/50" />
                ) : (
                  <ArrowUpRight size={18} strokeWidth={1.25} className="text-plum-700/50 group-hover:text-clay-300 group-hover:rotate-12 transition-all" />
                )}
              </div>

              {q.merchant_name && (
                <div className="phenix-eyebrow text-pink-500 group-hover:text-clay-300 group-hover:border-clay-300/30 mb-3">
                  chez {q.merchant_name}
                </div>
              )}
              <h3 className={`editorial-title text-4xl mb-4 ${q.played ? "text-plum-700/70" : "text-ink-900 group-hover:text-paper-100"} transition-colors`}>
                {q.title}
              </h3>
              <p className={`text-sm leading-relaxed mb-10 max-w-md ${q.played ? "text-plum-700/50" : "text-plum-700/70 group-hover:text-paper-100/60"} transition-colors`}>
                {q.description}
              </p>

              <div className={`border-t pt-5 ${q.played ? "border-cream-200" : "border-cream-200 group-hover:border-paper-100/15"} transition-colors`}>
                <div className={`phenix-eyebrow mb-2 ${q.played ? "" : "group-hover:text-paper-100/50 group-hover:border-paper-100/20 group-hover:bg-transparent"}`}>
                  Récompense
                </div>
                <div className={`font-display text-2xl ${q.played ? "text-plum-700/70" : "text-ink-900 group-hover:text-clay-300"} transition-colors`}>
                  {q.reward_label}
                </div>
              </div>

              {q.won && (
                <div className="absolute top-10 right-10 phenix-pill text-pink-500 border-clay-600/30 bg-clay-50">
                  Gagné
                </div>
              )}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
